import { render, staticRenderFns } from "./verification-record.vue?vue&type=template&id=597f68bf&scoped=true"
import script from "./verification-record.vue?vue&type=script&lang=js"
export * from "./verification-record.vue?vue&type=script&lang=js"
import style0 from "./verification-record.vue?vue&type=style&index=0&id=597f68bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597f68bf",
  null
  
)

export default component.exports